export default __webpack_public_path__ + "static/media/038-warship.83b06196.svg";